// extracted by mini-css-extract-plugin
module.exports = {"draggableItem":"select-question_draggableItem__GnF5q"};